var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5H3C1.3125 0.5 0 1.85938 0 3.5V18.5C0 20.1875 1.3125 21.5 3 21.5H18C19.6406 21.5 21 20.1875 21 18.5V3.5C21 1.85938 19.6406 0.5 18 0.5ZM9.375 6.125C9.375 5.51562 9.84375 5 10.5 5C11.1094 5 11.625 5.51562 11.625 6.125V12.125C11.625 12.7812 11.1094 13.25 10.5 13.25C9.84375 13.25 9.375 12.7812 9.375 12.125V6.125ZM10.5 17.75C9.65625 17.75 9 17.0938 9 16.2969C9 15.5 9.65625 14.8438 10.5 14.8438C11.2969 14.8438 11.9531 15.5 11.9531 16.2969C11.9531 17.0938 11.2969 17.75 10.5 17.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c28d4ef7549777400544b6a70a196cc8.svg";
export { ForwardRef as ReactComponent };